import React from "react";

function GeneralInfo()
{
    return(
        <div className="general-info-container">
<div className="general-info-text-content">
    <div className="general-info-text-box">
    <div className="general-info-heading">Welcome</div>
    <div className="general-info-text">
        <p>I’m Sogdiana, a tattoo artist from Central Asia, specializing in realistic and micro-realistic tattoos in color and black & grey.
My work focuses on precision, fine detail, and timeless artistry.</p>
    </div>
</div>
<div className="general-info-text-box">
    <div className="general-info-heading">Booking information</div>
    <div className="general-info-text">
        <p>Before booking, please read the following terms carefully.</p>
        <p>When submitting a request, describe your tattoo idea in detail and include all reference images you like.
At the first session, we’ll discuss and finalize your design together.
Designs are not prepared in advance — this creative process usually takes 1–2 hours and is included in the session time.

For large projects, I can arrange a video consultation beforehand to discuss design details.</p>
    </div>
</div>
<div className="general-info-text-box">
    <div className="general-info-heading">Project duration</div>
    <div className="general-info-text">
        <ul>
            <li><span style={{fontWeight:'bold'}}>Full sleeves / back pieces:</span> usually 9–12 sessions</li>
            <li><span style={{fontWeight:'bold'}}>Leg sleeves:</span> usually 14–20 sessions</li>
        </ul>
        <p>The exact number depends on skin type, size, and design detail, as each client is unique.</p>
        <p>As this is an artistic project, there is no way to guarantee the exact amount of time </p>
    </div>
</div>
<div className="general-info-text-box">
    <div className="general-info-heading">Session details</div>
    <div className="general-info-text">
        <ul>
            <li><span style={{fontWeight:'bold'}}>Working hours:</span> 12:00 PM – 7:30 PM</li>
            <li>Includes one lunch break and one coffee break</li>
            <li>If you’re late, the session will still end at 7:30 PM and will be charged in full
</li>
        </ul>
    </div>
</div>
<div className="general-info-text-box">
    <div className="general-info-heading">Please:</div>
    <div className="general-info-text">
        <ul>
            <li>Avoid alcohol for several days before your appointment</li>
            <li>Rest well and eat beforehand to maintain energy</li>
            <li>Bring your own lunch or snacks — a fridge and microwave are available</li>
        </ul>
    </div>
</div>
<div className="general-info-text-box">
    <div className="general-info-heading">Payment and Deposits</div>
    <div className="general-info-text">
        <ul>
            <li><span style={{fontWeight:'bold'}}>Full-day session:</span> $2,200</li>
            <li><span style={{fontWeight:'bold'}}>Hourly rate:</span> $300/hour (for smaller or time-based projects)</li>
            <li>Payment is due immediately after each session</li>
        </ul>
        <p>A $500 non-refundable deposit is required to confirm your booking.
It can be paid in cash, via Zelle, or Venmo.
The deposit secures your dates and will be applied to your final session (or your single session, if applicable).</p>
    </div>
</div>
<div className="general-info-text-box">
    <div className="general-info-heading">Rescheduling Policy</div>
    <div className="general-info-text">
        <p>If you need to reschedule, please notify me at least 7 days in advance.
Changes made later will require a new deposit.
You may reschedule once without losing your deposit.</p>
<p>If you are over 30 minutes late without notice, the session will be canceled without refund.</p>
<p>No-shows result in the loss of your deposit, and we will not be able to continue working together.</p>
    </div>
</div>
<div className="general-info-text-box">
    <div className="general-info-heading">Health Notice</div>
    <div className="general-info-text">
        <p>Please inform me in advance of any health conditions, allergies, or contraindications.</p>
    </div>
</div>
</div>
        </div>
    )
}
export default GeneralInfo;